export default {
	parent: null,
	user: null,
	dependent_member: null,
	event: null,
	extra_data: [],
	only_as_organizer: false,
	promo_code: ''
}
